import { DirectiveFunction } from 'vue';
import kebabCase from 'lodash/kebabCase';
import { AnalyticPayload, AnalyticUiEvent } from '@/scripts/libs/analytic/types';

const applyDataEventAttributes = (el: HTMLElement, tracker: Record<string, any>): void => {
  Object
    .entries(tracker)
    .filter(([, value]) => value != null)
    .forEach(([key, value]) => {
      el.setAttribute(`data-event-${kebabCase(key)}`, value);
    })
  ;
};

export const analyticEventDirective: DirectiveFunction = (el, { value }): void => {
  const tracker: AnalyticPayload = value;
  if (!tracker) return;

  applyDataEventAttributes(el, tracker);
};

export const analyticUiEventDirective: DirectiveFunction = (el, { value }): void => {
  const tracker: AnalyticUiEvent = value;
  if (!tracker) return;

  applyDataEventAttributes(el, {
    type: 'ui_event',
    ...tracker,
  });
};
